var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 1 7.88 5.087l6.977 4.089 7.107-4.089L14.857 1zm1.147 21.824V31l9.476-5.406v-8.177l-9.476 5.407zm7.108-15.166v8.178l-7.11 4.088v-8.177l7.11-4.089zM6 15.836l7.11 4.088v-8.177L6 7.658v8.178zm0 11.077L13.11 31v-8.176L6 18.737v8.177z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnt);
export default __webpack_public_path__ + "static/media/BNT.cad759417f1b8df0709bf2f4f3bfd94b.svg";
export { ForwardRef as ReactComponent };